import Administrators from './Administrators';

export default Administrators;
